import React, { Fragment, useState } from "react";
import { Card } from "react-bootstrap";
import {
    Checkbox,
    Button,
    Box,
    Switch,
    FormGroup,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@material-ui/core"; import { FormControlLabel, IconButton, TextField, MenuItem } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { buttonStyle } from "../../../Style/ManualStyle";
import { useDispatch, useSelector } from "react-redux";
import { getAllJobs, setBackendJobs } from "../../../Utils/actions";
import { loadingOn } from "../../../Utils/utils";
import cogoToast from "cogo-toast";

const KeyVault = () => {

    const dispatch = useDispatch();
    const [form, setForm] = useState({
        keyName: "",
        tenentId: "",
        clientId: "",
        clientSecret: "",
    });
    const [error, setError] = useState({
        keyName: "",
        tenentId: "",
        clientId: "",
        clientSecret: "",
    });
    const textFields = {
        margin: "5px",
        padding: "10px",
        height: "70px",
        gap: "15px",
    };
    const textFld = { margin: "5px", padding: "0px", display: "flex" };
    const switchtextFld = { marginLeft: "10px", display: "block" };
    const [openConfirm, setOpenConfirm] = useState(false);

    const handleOpenConfirm = () => {
        setOpenConfirm(true);
    };
    const handleSetting = (e) => {
        let value = e.target.value === "0" ? "" : e.target.value;
        setForm({ ...form, [e.target.name]: value });
    };

    const handleChange = (e) => {
        setError({ ...error, [e.target.name]: "" });
        setForm({ ...form, [e.target.name]: e.target.value.toString() });
    };

    const handleCloseConfirm = () => {
        setOpenConfirm(false);
    };

    const handleConfirmSubmit = (e) => {
        handleSubmit(e);
        handleCloseConfirm();
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        let newErrors = { ...error };

        // Validate all fields
        if (!form.keyName.trim()) newErrors.keyName = "Name is required";
        if (!form.tenentId.trim()) newErrors.tenentId = "Tenent Id is required";
        if (!form.clientId.trim()) newErrors.clientId = "Client Id is required";
        if (!form.clientSecret.trim()) newErrors.clientSecret = "Client Secret is required";

        // Update error state with all errors
        setError(newErrors);

        // Check for any errors
        const hasErrors = Object.values(newErrors).some((err) => err !== "");
        if (hasErrors) {
            console.log("Errors found:", newErrors); // Debugging
            return;
        }

        // Proceed with submission
        const data = [
            {
                propertyKey: "iot.veras.azure.keyvault.name",
                propertyValue: form.keyName,
            },
            {
                propertyKey: "iot.veras.azure.keyvault.tenantId",
                propertyValue: form.tenentId,
            },
            {
                propertyKey: "iot.veras.azure.keyvault.clientId",
                propertyValue: form.clientId,
            },
            {
                propertyKey: "iot.veras.azure.keyvault.clientSecret",
                propertyValue: form.clientSecret,
            },
        ];

        try {
            dispatch(loadingOn());
            dispatch(setBackendJobs(data));
        } catch (err) {
            cogoToast.error("Not successful");
            console.error("Submission error:", err); // Debugging
        }
    };

    return (<>
        <Card
            className={"shadow-none w-100 backendjobs-card"}
            style={{
                backgroundColor: "#333333",
                padding: "15px",
                overflow: "auto",
                height: "89vh",
                border: "none",
                borderRadius: "unset",
            }}
        >
            <Card.Body
                className={"backendjobs_content"}
                style={{
                    borderRadius: "0.25rem",
                    background: "#fff",
                    overflow: "auto",
                    backgroundColor: "#242424",
                }}
            >
                <div
                    className="col-md-10 backfill-form"
                    style={{ paddingTop: "5px", paddingLeft: "5px" }}
                >
                    <Box
                        component="form"
                        className="addUserBox"
                        onSubmit={(e) => e.preventDefault()}
                        noValidate
                        autoComplete="off"
                    >
                        <div className="textBoxes d-block">
                            <div className="main1">
                                <h6
                                    style={{
                                        backgroundColor: "#333333",
                                        fontWeight: "700",
                                        padding: "10px",
                                        color: "#c7c7c7",
                                        marginBottom: "20px",
                                    }}
                                >
                                    Key Vault Configuration
                                </h6>

                                <div
                                    className="col-md-12 d-flex align-items-center"
                                    style={textFields}
                                >

                                    <div
                                        className="server-info app-txt"
                                        style={{ switchtextFld, flex: "0 0 200px" }}
                                    >
                                        <TextField
                                            type="text"
                                            name="keyName"
                                            label="Name"
                                            value={form.keyName}
                                            onFocus={handleSetting}
                                            onChange={handleChange}
                                            required
                                            error={!!error.keyName}
                                            helperText={error.keyName}
                                            size="small"
                                        />
                                    </div>

                                    <div
                                        className="app-txt"
                                        style={{ textFld, flex: "0 0 200px" }}
                                    >
                                        <TextField
                                            type="number"
                                            name="tenentId"
                                            label="Tenent Id"
                                            value={form.tenentId}
                                            onFocus={handleSetting}
                                            onChange={handleChange}
                                            required
                                            error={!!error.tenentId}
                                            helperText={error.tenentId}
                                            size="small"
                                        />
                                    </div>
                                    <div
                                        className="app-txt"
                                        style={{ textFld, flex: "0 0 200px" }}
                                    >
                                        <TextField
                                            type="text"
                                            name="clientId"
                                            label="Client Id"
                                            value={form.clientId}
                                            onFocus={handleSetting}
                                            onChange={handleChange}
                                            required
                                            error={!!error.clientId}
                                            helperText={error.clientId}
                                            size="small"
                                        />
                                    </div>
                                    <div
                                        className="app-txt"
                                        style={{ textFld, flex: "0 0 200px" }}
                                    >
                                        <TextField
                                            type="text"
                                            name="clientSecret"
                                            label="Client Secret"
                                            value={form.clientSecret}
                                            onFocus={handleSetting}
                                            onChange={handleChange}
                                            required
                                            error={!!error.clientSecret}
                                            helperText={error.clientSecret}
                                            size="small"
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                        <Button
                            className="submit-btn"
                            type="button"
                            startIcon={<SaveIcon />}
                            style={{
                                ...buttonStyle,
                                width: "100px",
                                left: "15px",
                                marginTop: "10px",
                            }}
                            onClick={handleOpenConfirm}
                        >
                            Save
                        </Button>
                    </Box>
                </div>
            </Card.Body>
        </Card>
        <Dialog
            open={openConfirm}
            onClose={handleCloseConfirm}
            aria-labelledby="confirm-dialog-title"
        >
            <DialogTitle
                id="confirm-dialog-title"
                style={{
                    backgroundColor: "#464545fb",
                    color: "#c7c7c7",
                }}
            >
                Confirm Save
            </DialogTitle>

            <DialogContent>
                Are you sure you want to save the changes?
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleCloseConfirm}
                    variant="contained"
                    color="secondary"
                    style={{ ...buttonStyle }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirmSubmit}
                    color="primary"
                    variant="contained"
                    startIcon={<SaveIcon />}
                    style={{
                        ...buttonStyle,
                    }}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    </>);
}

export default KeyVault;